import clsx from 'clsx';
import React from 'react';
import { MaskedTextField } from '../ui/MaskedTextField';

export enum VerificationStepCardStatus {
  SUCCESS = 'success',
  PENDING = 'pending',
  OPTIONAL = 'optional',
}

type VerificationStepCardProps = {
  icon: string;
  iconAlt?: string;
  status: VerificationStepCardStatus;
  title: string;
  description?: string;
  disabled?: boolean;
  showInput?: boolean;
  inputValue?: string;
  onInputChange?: (value: string) => void;
};

export const VerificationStepCard: React.FC<VerificationStepCardProps> = ({
  icon,
  iconAlt = 'Step icon',
  status,
  title,
  description,
  disabled = false,
  showInput = false,
  inputValue = '',
  onInputChange,
}) => {
  const statusText: Record<VerificationStepCardStatus, string> = {
    [VerificationStepCardStatus.SUCCESS]: 'Success',
    [VerificationStepCardStatus.PENDING]: 'Pending',
    [VerificationStepCardStatus.OPTIONAL]: 'Optional',
  };

  return (
    <div
      className={clsx(
        'border-gray-200 border-2 rounded-2xl p-6 flex flex-col justify-between w-[240px] min-h-[280px]',
        disabled && 'bg-gray-100 opacity-50 cursor-not-allowed'
      )}
    >
      <div className="flex items-center gap-3 w-full justify-between">
        <div className="w-7 h-7 flex items-center justify-center">
          <img src={icon} alt={iconAlt} className="w-full h-full object-contain" />
        </div>
        <div
          className={clsx(
            'px-3 py-1 rounded-full text-xs font-medium',
            status === 'success' ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-700'
          )}
        >
          {statusText[status]}
        </div>
      </div>
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <h3 className="text-lg font-semibold text-black">{title}</h3>
          {description && <p className="text-sm text-gray-600 leading-relaxed">{description}</p>}
        </div>

        {showInput && !disabled && (
          <div>
            <MaskedTextField
              value={inputValue}
              onChange={onInputChange || (() => {})}
              mask="______"
              disabled={disabled}
            />
          </div>
        )}
      </div>
    </div>
  );
};
